<template>
  <Layout>
    <div slot="content">
      <div class="row">
        <div class="col-xl-6">
          <TableView hide-pagenation @action="action" :title="$t('권한')" :columns="cols" :list="roleList" 
            :icon-actions="{'bi-pencil-fill': '수정', 'bi-trash-fill': '권한삭제'}" min-width="auto" minHeight="450px">
            <button class="btn btn-primary" @click="sel = {}; list = []; action({ action: '추가', item: {} })" 
              v-text="$t('권한 추가')" />
          </TableView>
        </div>
        <div class="col-xl-6">
          <TableView :title="sel.roleNm || ''" :list="list" :columns="roleCols" min-width="auto" minHeight="450px" @action="delUser" :actions="['삭제']">
            <div class="d-flex align-items-center position-relative">
              <b-icon icon="search" />
              <input maxlength="100" @change="getList({ searchKeyword: $event.target.value })" @keydown="handleKeyDown"
                class="form-control form-control-solid w-200px ps-11" :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')">
              <button v-text="$t('사용자 배정')" :disabled="!sel.roleId" class="ms-3 btn btn-primary" @click="subAction({ action: '배정' })" />
            </div>
          </TableView>
        </div>
      </div>
    </div>
    

    <ModalForm id="edit" :label-cols="3" ok-title="저장" @action="action" :title="$t(sel.roleId ? '권한 수정' : '권한 추가')"  no-close-on-ok
      :data="sel" :spec="cols">
      <template slot="bottom">
        <!-- <div v-for="(list, title, i) of roles" :key="'role' + i"
          class="role-roles form-switch form-check-sm form-check-custom form-check-solid">
          <h5><label v-text="title" :for="`role${i}`" /><input
            @change="({ target: { checked } }) => list.forEach(r => r.roleYn = checked ? 'Y' : 'N')"
            v-model="roleChecks[i]" :id="`role${i}`" type="checkbox" class="form-check-input" /></h5>
          <div v-for="(sub, j) of list" :key="j"><label v-text="sub.actionNm" :for="`role${i}_${j}`" /><input
            :checked="list[j].roleYn == 'Y'" @change="({ target: { checked } }) => list[j].roleYn = checked ? 'Y' : 'N'"
            :id="`role${i}_${j}`" type="checkbox" class="form-check-input" /></div>
        </div> -->
        <div v-for="(list, title, i) of roles" :key="'role' + i"
          class="role-roles form-switch form-check-sm form-check-custom form-check-solid">
          <h5><label v-text="title" :for="`role${i}`" /><input
              @change="({ target: { checked } }) => list.forEach(c => c.roleActionList.forEach(r => r.roleYn = checked ? 'Y' : 'N'))"
              v-model="roleChecks[i]" :id="`role${i}`" type="checkbox" class="form-check-input" /></h5>
            <div v-for="(cat, k) of list" :key="k"><label v-if="cat.dispYn=='Y'" style="margin: 0 0 5px -15px;color:green" v-text="cat.cateNm" />
              <div v-for="(sub, j) of cat.roleActionList" :key="j"><label v-text="sub.actionNm" :for="`role${i}_${j}_${k}`" /><input
                :checked="list[k].roleActionList[j].roleYn == 'Y'" @change="({ target: { checked } }) => list[k].roleActionList[j].roleYn = checked ? 'Y' : 'N'"
                :id="`role${i}_${j}_${k}`" type="checkbox" class="form-check-input" /></div>
            </div>
        </div>
      </template>
    </ModalForm>

    <ModalForm id="배정" size="lg" :title="$t('사용자 배정')" body-class="p-0" scrollable hide-footer>
      <TableView @action="userSelAction" :title="$t('배정 가능 사용자')" @nextList="nextList" :actions="['선택']"
        :columns="userSelCols" :data="sel" :list="srcUserList" :server-total="total" minWidth="600px">
        <div class="d-flex align-items-center position-relative me-3">
          <b-icon icon="search" />
          <input @change="searchKeyword = $event.target.value" class="form-control form-control-solid w-250px ps-11" @keydown="assignKeydowm"
            :placeholder="$t('사용자명, 아이디, 이메일, 연락처')" :title="$t('사용자명, 아이디, 이메일, 연락처')" @keyup.enter.stop >
        </div>
        <b-button variant="light-primary" v-b-modal.상세>
          <b-icon icon="filter" /> {{ $t('상세') }}
        </b-button>
      </TableView>
    </ModalForm>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    roles: {}, sel: {}, selSub: {},
    roleChecks: [], list: [], srcUserList: [], roleList: [],
    searchKeyword: '', 
    total: 0,
    cols: [
      { key: 'roleNm', label: '권한명', required, form: 1, style: { textAlign: 'center' } },
      { key: 'description', label: '설명', type: 'textarea', form: 2 },
    ],
    roleCols: [
      { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
    ],
    userSelCols: [
      { label: '사용자', renderer: item => `${item.userNm} (${item.userIdText})`, style: { textAlign: 'center' } },
      { key: 'email', label: '이메일', type: 'email', style: { textAlign: 'center' } },
      { key: 'phone', label: '연락처', type: 'tel', style: { textAlign: 'center' } },
    ],
  }),
  watch: { searchKeyword() { this.getList(); this.getRoleList();} },
  async created() { this.getRoleList(); },
  mounted() {
    this.$reduceScreen();
  },
  computed: {},
  methods: {
    async getList(opt = {}) {   // 권한에 배정된 사용자 목록 조회
      this.list = [];
      this.list = (await this.$api('adm/role/selectRoleUserList', { roleId: this.sel.roleId, searchKeyword: opt.searchKeyword || null })).list || [];
    },
    async getRoleList() {   // 권한 목록 조회
      this.roleList = (await this.$api('adm/role/selectRoleList', {})).list || [];
      this.$nextTick(() => { this.list = []; });
    },
    async action({ action, item, form }) {
      if (item && item.roleNm) this.sel = item;
      if (['view'].includes(action)) return this.getList();
      else if (!form && ['수정', '추가'].includes(action)) {
        this.roles = {};
        this.roleChecks.length = 0;
        const { data: { roleActionList, topMenuList, actionCateList } } = await this.$api('adm/role/selectRoleActionList', { roleId: this.sel.roleId });
        actionCateList.forEach(c => c.roleActionList = roleActionList.filter(r => r.cateId == c.cateId));
        topMenuList.forEach(m => this.roles[`${m.menuNm}`] = actionCateList.filter(r => r.menuId == m.menuId));
        // topMenuList.forEach(m => this.roles[`${m.menuNm} ${this.$t('관리')}`] = roleActionList.filter(r => r.menuId == m.menuId));
        this.$forceUpdate();
        return this.$bvModal.show('edit');
      }
      else if (['권한삭제'].includes(action) && !(await this.$alert(this.$t('[$] 권한을 $ 하시겠습니까?', [item.roleNm, action]), { confirm: true }))) return;
      else if (form) {
        action = this.sel.roleId ? '수정' : '추가';
        let _roleActionList = [];
        Object.values(this.roles).forEach(role => {
          role.forEach(item => {
            if(item.hasOwnProperty('roleActionList')) { _roleActionList.push(...item.roleActionList); }
          });
        });
        const roleActionList = _roleActionList.map(({ actionId, roleYn }) => ({ actionId, roleYn }));
        Object.assign(form, { roleId: this.sel.roleId, roleActionList });
      }
      if (['edit'].includes(action) && (await this.$alert(this.$t('[$] 권한을 $ 하시겠습니까?', [this.sel.roleNm, action]), { confirm: true }))) return;
      const roleAct = await this.$api(`adm/role/${({ 권한삭제: 'deleteRole', 추가: 'insertRole', 수정: 'updateRole' })[action]}`, form || { roleId: item.roleId });
      await this.$alert(roleAct.msg);
      if (roleAct.success) this.$bvModal.hide('edit'); this.getRoleList();
    },
    //사용자 배정
    async userSelAction({ action, item, form }) {
      if (!form && ['view'].includes(action)) {return this.$bvModal.show('view');}
      const { roleId } = this.sel;
      const { userId } = item;
      const res = (await this.$api('adm/role/insertRoleUser', { userId, roleId }));
      await this.$alert(res.msg);
      this.srcUserList = (await this.$api('adm/role/selectRoleAssignUserList', { searchKeyword: this.searchKeyword })).list || [];
      this.getList();
    },
    async subAction({ action, item, form }) {
      if (item) this.selSub = item;
      else if (!form && ['배정'].includes(action)) {
        this.srcUserList = (await this.$api('adm/role/selectRoleAssignUserList', { searchKeyword: '' })).list || [];
        return this.$bvModal.show('배정');
      }
    },
    async delUser({ form, action, item }) {
      if (!form && ['view'].includes(action)) {
        return this.$bvModal.show('view');
      }
      const { roleId } = this.sel;
      const { userId } = item;
      if (!(await this.$alert(this.$t('[$] 사용자를 $ 하시겠습니까?', [item.userNm, action]), { confirm: true }))) return;
      const res = (await this.$api('adm/role/deleteRoleUser', { userId, roleId }));
      await this.$alert(res.msg);
      this.getList();
    },
    nextList() { if (this.total > this.list.length) this.getList(this.list.length + 1); },
    async handleKeyDown(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.list = [];
        this.list = (await this.$api('adm/role/selectRoleUserList', { roleId: this.sel.roleId, searchKeyword: event.target.value || null })).list || [];
      }
    },
    async assignKeydowm(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.srcUserList = (await this.$api('adm/role/selectRoleAssignUserList', { searchKeyword: event.target.value || null })).list || [];
      }
    },
  },
}
</script>
